import { render, staticRenderFns } from "./user-v2.vue?vue&type=template&id=4f384d22&scoped=true&"
import script from "./user-v2.vue?vue&type=script&lang=js&"
export * from "./user-v2.vue?vue&type=script&lang=js&"
import style0 from "./user-v2.vue?vue&type=style&index=0&id=4f384d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f384d22",
  null
  
)

export default component.exports